import {defineStore} from "pinia";
export const materialStore = defineStore("materialStore", {
    state: () =>
        ({
            loading: false as boolean,
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            materiales: [],
            materialesListado: [],
            grupoMaterial: [],
            partidaGasto: [],
            showDialogSancion: false as boolean,
            material: [],
            newMaterial:[],
            unidad: []
        }),
});